// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="0"]),
.ids-layout-flex-item-flex-0 {
  flex: 0;
  min-width: 0;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
  min-width: 0;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
  min-width: 0;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
  min-width: 0;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
  min-width: 0;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
  min-width: 0;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
  min-width: 0;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
  min-width: 0;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
  min-width: 0;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
  min-width: 0;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
  min-width: 0;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
  min-width: 0;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
  min-width: 0;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
  min-width: 0;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
  min-width: 0;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
  min-width: 0;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
  min-width: 0;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
  min-width: 0;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
  min-width: 0;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
  min-width: 0;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
  min-width: 0;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
  min-width: 0;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
  min-width: 0;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
  min-width: 0;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
  min-width: 0;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([hidden]) {
  display: none;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-flex/ids-layout-flex.scss","webpack://./src/components/ids-layout-flex/ids-layout-flex-item.scss"],"names":[],"mappings":"AAAA,8BAAA;ACAA,mCAAA;AAME;;EAEE,gBALc;ADElB;;ACCE;;EAEE,oBALc;ADOlB;;ACJE;;EAEE,kBALc;ADYlB;;ACTE;;EAEE,mBALc;ADiBlB;;ACdE;;EAEE,sBALc;ADsBlB;;ACnBE;;EAEE,oBALc;AD2BlB;;ACdE;;EAEE,YALa;ADsBjB;;ACnBE;;EAEE,YALa;AD2BjB;;ACdE;;EAEE,cALe;ADsBnB;;ACnBE;;EAEE,cALe;AD2BnB;;ACdE;;EAEE,OALQ;EAMR,YAAA;ADiBJ;;ACpBE;;EAEE,OALQ;EAMR,YAAA;ADuBJ;;AC1BE;;EAEE,OALQ;EAMR,YAAA;AD6BJ;;AChCE;;EAEE,OALQ;EAMR,YAAA;ADmCJ;;ACtCE;;EAEE,OALQ;EAMR,YAAA;ADyCJ;;AC5CE;;EAEE,OALQ;EAMR,YAAA;AD+CJ;;AClDE;;EAEE,OALQ;EAMR,YAAA;ADqDJ;;ACxDE;;EAEE,OALQ;EAMR,YAAA;AD2DJ;;AC9DE;;EAEE,OALQ;EAMR,YAAA;ADiEJ;;ACpEE;;EAEE,OALQ;EAMR,YAAA;ADuEJ;;AC1EE;;EAEE,QALQ;EAMR,YAAA;AD6EJ;;AChFE;;EAEE,QALQ;EAMR,YAAA;ADmFJ;;ACtFE;;EAEE,QALQ;EAMR,YAAA;ADyFJ;;AC5FE;;EAEE,QALQ;EAMR,YAAA;AD+FJ;;AClGE;;EAEE,QALQ;EAMR,YAAA;ADqGJ;;ACxGE;;EAEE,QALQ;EAMR,YAAA;AD2GJ;;AC9GE;;EAEE,QALQ;EAMR,YAAA;ADiHJ;;ACpHE;;EAEE,QALQ;EAMR,YAAA;ADuHJ;;AC1HE;;EAEE,QALQ;EAMR,YAAA;AD6HJ;;AChIE;;EAEE,QALQ;EAMR,YAAA;ADmIJ;;ACtIE;;EAEE,QALQ;EAMR,YAAA;ADyIJ;;AC5IE;;EAEE,QALQ;EAMR,YAAA;AD+IJ;;AClJE;;EAEE,QALQ;EAMR,YAAA;ADqJJ;;ACxJE;;EAEE,QALQ;EAMR,YAAA;AD2JJ;;AC9JE;;EAEE,QALQ;EAMR,YAAA;ADiKJ;;ACzJE;;EAEE,cALY;ADiKhB;;AC9JE;;EAEE,gBALY;ADsKhB;;ACnKE;;EAEE,iBALY;AD2KhB;;ACxKE;;EAEE,gBALY;ADgLhB;;ACrKA;;EAEE,WAAA;ADwKF;;ACrKA;EACE,qBAAA;ADwKF;;AAlOA;;EAEE,aAAA;AAqOF;;AAlOA;EACE,aAAA;AAqOF;;AAlOA;;EAEE,oBAAA;AAqOF;;AA9NE;;EAEE,yBALiB;AAsOrB;;AAnOE;;EAEE,uBALiB;AA2OrB;;AAxOE;;EAEE,qBALiB;AAgPrB;;AA7OE;;EAEE,4BALiB;AAqPrB;;AAlPE;;EAEE,2BALiB;AA0PrB;;AAvPE;;EAEE,2BALiB;AA+PrB;;AA5PE;;EAEE,sBALiB;AAoQrB;;AAjQE;;EAEE,oBALiB;AAyQrB;;AAtQE;;EAEE,kBALiB;AA8QrB;;AA3QE;;EAEE,uBALiB;AAmRrB;;AAtQE;;EAEE,kBALe;AA8QnB;;AA3QE;;EAEE,gBALe;AAmRnB;;AAhRE;;EAEE,uBALe;AAwRnB;;AArRE;;EAEE,qBALe;AA6RnB;;AA1RE;;EAEE,mBALe;AAkSnB;;AA/RE;;EAEE,qBALe;AAuSnB;;AApSE;;EAEE,oBALe;AA4SnB;;AA/RE;;EAEE,mBALkB;AAuStB;;AApSE;;EAEE,2BALkB;AA4StB;;AAzSE;;EAEE,sBALkB;AAiTtB;;AA9SE;;EAEE,8BALkB;AAsTtB;;AAzSE;;EAEE,sBALmB;AAiTvB;;AA9SE;;EAEE,wBALmB;AAsTvB;;AAnTE;;EAEE,oBALmB;AA2TvB;;AAxTE;;EAEE,2BALmB;AAgUvB;;AA7TE;;EAEE,yBALmB;AAqUvB;;AAlUE;;EAEE,uBALmB;AA0UvB;;AAvUE;;EAEE,qBALmB;AA+UvB;;AA5UE;;EAEE,sBALmB;AAoVvB;;AAjVE;;EAEE,8BALmB;AAyVvB;;AAtVE;;EAEE,6BALmB;AA8VvB;;AA3VE;;EAEE,6BALmB;AAmWvB;;AAtVE;;EAEE,iBALa;AA8VjB;;AA3VE;;EAEE,eALa;AAmWjB;;AAhWE;;EAEE,uBALa;AAwWjB;;AA1VE;;EAEE,QAAA;AA6VJ;;AA/VE;;EAEE,QAAA;AAkWJ;;AApWE;;EAEE,QAAA;AAuWJ;;AAzWE;;EAEE,QAAA;AA4WJ;;AA9WE;;EAEE,QAAA;AAiXJ;;AAnXE;;EAEE,SAAA;AAsXJ;;AAxXE;;EAEE,SAAA;AA2XJ;;AA7XE;;EAEE,SAAA;AAgYJ;;AAlYE;;EAEE,SAAA;AAqYJ;;AAvYE;;EAEE,SAAA;AA0YJ;;AA5YE;;EAEE,SAAA;AA+YJ;;AAjZE;;EAEE,SAAA;AAoZJ;;AAtZE;;EAEE,SAAA;AAyZJ;;AAnZE;;EAEE,YAAA;AAsZJ;;AAxZE;;EAEE,YAAA;AA2ZJ;;AA7ZE;;EAEE,YAAA;AAgaJ;;AAlaE;;EAEE,YAAA;AAqaJ;;AAvaE;;EAEE,YAAA;AA0aJ;;AA5aE;;EAEE,aAAA;AA+aJ;;AAjbE;;EAEE,aAAA;AAobJ;;AAtbE;;EAEE,aAAA;AAybJ;;AA3bE;;EAEE,aAAA;AA8bJ;;AAhcE;;EAEE,aAAA;AAmcJ;;AArcE;;EAEE,aAAA;AAwcJ;;AA1cE;;EAEE,aAAA;AA6cJ;;AA/cE;;EAEE,aAAA;AAkdJ;;AA5cE;;EAEE,eAAA;AA+cJ;;AAjdE;;EAEE,eAAA;AAodJ;;AAtdE;;EAEE,eAAA;AAydJ;;AA3dE;;EAEE,eAAA;AA8dJ;;AAheE;;EAEE,eAAA;AAmeJ;;AAreE;;EAEE,gBAAA;AAweJ;;AA1eE;;EAEE,gBAAA;AA6eJ;;AA/eE;;EAEE,gBAAA;AAkfJ;;AApfE;;EAEE,gBAAA;AAufJ;;AAzfE;;EAEE,gBAAA;AA4fJ;;AA9fE;;EAEE,gBAAA;AAigBJ;;AAngBE;;EAEE,gBAAA;AAsgBJ;;AAxgBE;;EAEE,gBAAA;AA2gBJ;;AAtgBA;;EAEE,YAAA;AAygBF;;AArgBA;;EAEE,oBAAA;AAwgBF","sourcesContent":["/* Ids Layout Flex Component */\n@use './ids-layout-flex-item' as *;\n\n:host,\n.ids-layout-flex {\n  display: flex;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host([display='inline-flex']),\n.ids-layout-flex-display-inline-flex {\n  display: inline-flex;\n}\n\n// Align-content\n$align-content-list: flex-start flex-end center space-between space-around space-evenly stretch start end baseline;\n\n@each $align-content in $align-content-list {\n  :host([align-content='#{$align-content}']),\n  .ids-layout-flex-align-content-#{$align-content} {\n    align-content: $align-content;\n  }\n}\n\n// Align-items\n$align-items-list: start end flex-start flex-end center baseline stretch;\n\n@each $align-items in $align-items-list {\n  :host([align-items='#{$align-items}']),\n  .ids-layout-flex-align-items-#{$align-items} {\n    align-items: $align-items;\n  }\n}\n\n// Direction\n$flex-direction-list: row row-reverse column column-reverse;\n\n@each $flex-direction in $flex-direction-list {\n  :host([direction='#{$flex-direction}']),\n  .ids-layout-flex-direction-#{$flex-direction} {\n    flex-direction: $flex-direction;\n  }\n}\n\n// Justify-content\n$justify-content-list: start stretch end flex-start flex-end center left right space-between space-around space-evenly;\n\n@each $justify-content in $justify-content-list {\n  :host([justify-content='#{$justify-content}']),\n  .ids-layout-flex-justify-content-#{$justify-content} {\n    justify-content: $justify-content;\n  }\n}\n\n// Wrap\n$flex-wrap-list: nowrap wrap wrap-reverse;\n\n@each $flex-wrap in $flex-wrap-list {\n  :host([wrap='#{$flex-wrap}']),\n  .ids-layout-flex-wrap-#{$flex-wrap} {\n    flex-wrap: $flex-wrap;\n  }\n}\n\n// Units\n$units: 0 1 2 4 8 12 16 20 24 28 32 36 40;\n\n// Gap for both horizontal and vertical\n@each $gap in $units {\n  :host([gap='#{$gap}']),\n  .ids-layout-flex-gap-#{$gap} {\n    gap: #{$gap}px;\n  }\n}\n\n// Horizontal gap (row-gap)\n@each $gap-x in $units {\n  :host([gap-x='#{$gap-x}']),\n  .ids-layout-flex-gap-x-#{$gap-x} {\n    row-gap: #{$gap-x}px;\n  }\n}\n\n// Vertical gap (column-gap)\n@each $gap-y in $units {\n  :host([gap-y='#{$gap-y}']),\n  .ids-layout-flex-gap-y-#{$gap-y} {\n    column-gap: #{$gap-y}px;\n  }\n}\n\n// Full Height\n:host([full-height]),\n.ids-layout-flex-full-height {\n  height: 100%;\n}\n\n// Fix icons\n::slotted(ids-icon),\n.ids-layout-flex > .ids-icon {\n  display: inline-flex;\n}\n","/* Ids Layout Flex Item Component */\n\n// Align-self\n$align-self-list: auto baseline center stretch flex-start flex-end;\n\n@each $align-self in $align-self-list {\n  :host([align-self='#{$align-self}']),\n  .ids-layout-flex-item-align-self-#{$align-self} {\n    align-self: $align-self;\n  }\n}\n\n// Flex-grow\n$flex-grow-list: 0 1;\n\n@each $flex-grow in $flex-grow-list {\n  :host([grow='#{$flex-grow}']),\n  .ids-layout-flex-item-grow-#{$flex-grow} {\n    flex-grow: $flex-grow;\n  }\n}\n\n// Flex-shrink\n$flex-shrink-list: 0 1;\n\n@each $flex-shrink in $flex-shrink-list {\n  :host([shrink='#{$flex-shrink}']),\n  .ids-layout-flex-item-shrink-#{$flex-shrink} {\n    flex-shrink: $flex-shrink;\n  }\n}\n\n// Flex\n$flex-list: 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24;\n\n@each $flex in $flex-list {\n  :host([flex='#{$flex}']),\n  .ids-layout-flex-item-flex-#{$flex} {\n    flex: $flex;\n    min-width: 0;\n  }\n}\n\n// Overflow\n$overflow-list: auto hidden visible scroll;\n\n@each $overflow in $overflow-list {\n  :host([overflow='#{$overflow}']),\n  .ids-layout-flex-item-overflow-#{$overflow} {\n    overflow: $overflow;\n  }\n}\n\n// grow/shrink=0 override - class-based workaround for container grid collapse\n// Note: :has(::slotted()) is invalid CSS due to Shadow DOM spec limitations\n:host(.has-container-grid[grow='0'][shrink='0']),\n.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {\n  width: 100%;\n}\n\n::slotted(ids-input[size=\"full\"]) {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
